import { Card, CardBody, Col } from 'reactstrap'
import { FormFloatingHeading } from '../../../../../Utils/Constants'
import { floatingFormSubTitle } from '../../../../../Data/Forms/FormsControl/BaseInput/BaseInput'
import FormFloating from './FormFloating'
import CardHeaderCommon from '../../../../../Utils/CommonComponents/CardHeaderCommon'

const FloatingForm = () => {
  return (
    <Col md="6">
      <Card>
        <CardHeaderCommon title={FormFloatingHeading} span={floatingFormSubTitle}/>
        <CardBody>
          <div className="card-wrapper border rounded-3">
            <FormFloating />
          </div>
        </CardBody>
      </Card>
    </Col>
  )
}

export default FloatingForm